import { useDeviceType } from '@braskai/ui-kit';

import { Chip, Stack } from '@mui/material';

type DiscountChipProps = {
  label: string;
};

export const DiscountChip = ({ label }: DiscountChipProps) => {
  const { isMobile } = useDeviceType();

  return (
    <Stack sx={{ position: 'absolute', right: isMobile ? 20 : 23, top: -13 }}>
      <Chip label={label} color="primary" size="small" />
    </Stack>
  );
};
